const FanType = [
  { id: 1, name: 'Supply Only' },
  { id: 2, name: 'Exhaust Only' },
  { id: 3, name: 'Supply and Exhaust' }
]

export default FanType
